export default {
  DEFAULT: "default",
  PRODUCT_IMPRESSION: "product_impression",
  PRODUCT_CLICK: "product_click",
};



// WEBPACK FOOTER //
// ./src/analytics/eventFactory/LogmanEvents.js